import createFormContext from '../../../../context/formContext'

const { FormStateProvider : StateFormProvider, useStore: useFormState } = createFormContext({
    id: "",
    loaded: false,
    savedOn: "",
});

export { StateFormProvider, useFormState };
